module.exports = __webpack_public_path__ + "static/img/car_12_5_box@3x.7cad9d93.png";